import React, { useState } from "react";
import { DialogActions, Typography } from "@material-ui/core";
import { FieldArray, useFormikContext } from "formik";
import DialogLayout from "../../../../../partials/content/DialogLayout";
import {
  getRandomColor,
  createImageFromInitials,
} from "../../../../../partials/layout/Avatar";
import { Image } from "react-bootstrap";
import { Card } from "react-bootstrap";
import SearchUser from "../../../users/users/searchUser";
import BootstrapTooltip from "../../../../../partials/content/BootstrapTooltip";
import { FormArrayTextField } from "../../../../../partials/content/Forms/FormField";
const JourneyTeam = (props) => {
  const [openSearchUser, setOpenSearchUser] = useState(false);
  const [userSelectedIndex, setUserSelectedIndex] = useState(0);
  const { values, setFieldValue } = useFormikContext();
  return (
    <React.Fragment>
      <FieldArray name="teams">
        {({ push, remove }) => (
          <React.Fragment>
            <Card>
              <Card.Header>
                <i className="fas fa-users"></i>
                <span>
                  <strong>Sales Journey Teams</strong>
                </span>
              </Card.Header>
              <Card.Body>
                <div className="row mb-3">
                  <div className="col-sm-12 col-md-12 col-lg-12">
                    <button
                      type="button"
                      className="btn btn-primary btn-md btn-pill btn-bold"
                      onClick={() => {
                        push({
                          ID: 0,
                          statusID: 1,
                          userID: 0,
                          userName: "",
                          user: {
                            userImage: [],
                          },
                          description: "",
                        });
                      }}
                    >
                      <i className="fas fa-plus-circle"></i>
                      Add Team Member
                    </button>
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-12 col-md-12 col-lg-12">
                    <div className="row">
                      {values.teams && values.teams.length > 0
                        ? values.teams.map((item, index) => (
                            <React.Fragment key={index}>
                              <div className="col-sm-3 col-md-3 col-lg-3">
                                <Card className="text-center my-2">
                                  <Card.Header>
                                    {item.user.userImage ? (
                                      <Typography align="center">
                                        <Image
                                          src={
                                            item.user.userImage.length === 0
                                              ? createImageFromInitials(
                                                  150,
                                                  item.userName,
                                                  getRandomColor()
                                                )
                                              : item.user.userImage[0].imagePath
                                          }
                                          style={{
                                            maxHeight: "100px",
                                          }}
                                          alt="Avatar"
                                          roundedCircle
                                          fluid
                                        />
                                      </Typography>
                                    ) : null}
                                    {index > 0 ? (
                                      <div className="row justify-content-center image-button-container-theme">
                                        <div className="col-sm-12 col-md-12 col-lg-12">
                                          <Typography align="center">
                                            <BootstrapTooltip title="Delete User">
                                              <button
                                                type="button"
                                                className="btn btn-icon btn-label-danger btn-md btn-circle mx-1 image-button-theme"
                                                onClick={() => {
                                                  remove(index);
                                                }}
                                              >
                                                <i className="fas fa-trash-alt"></i>
                                              </button>
                                            </BootstrapTooltip>
                                          </Typography>
                                        </div>
                                      </div>
                                    ) : null}
                                  </Card.Header>
                                  <Card.Body>
                                    <div className="row">
                                      <div className="col-sm-12 col-md-12 col-lg-12">
                                        <FormArrayTextField
                                          arrayPropName="teams"
                                          index={index}
                                          propName="userName"
                                          label="Sales Name"
                                          searchButton
                                          readonly
                                          onSearchClick={() => {
                                            setUserSelectedIndex(index);
                                            setOpenSearchUser(true);
                                          }}
                                        />
                                        <FormArrayTextField
                                          arrayPropName="teams"
                                          index={index}
                                          label="Role Description"
                                          propName="description"
                                        />
                                      </div>
                                    </div>
                                  </Card.Body>
                                </Card>
                              </div>
                            </React.Fragment>
                          ))
                        : null}
                    </div>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </React.Fragment>
        )}
      </FieldArray>
      <DialogLayout
        open={openSearchUser}
        title="Search User"
        onCloseDialog={handleCloseSearchUser}
        maxWIdth="lg"
      >
        <SearchUser
          onSelectUser={(user) => {
            setFieldValue(`teams[${userSelectedIndex}].userID`, user.ID);
            setFieldValue(
              `teams[${userSelectedIndex}].userName`,
              user.firstName + " " + user.lastName
            );
            handleCloseSearchUser();
          }}
        />
        <DialogActions>
          <button
            type="button"
            className="btn btn-label-danger btn-md btn-pill btn-bold"
            onClick={handleCloseSearchUser}
          >
            <i className="fas fa-window-close"></i>
            Close
          </button>
        </DialogActions>
      </DialogLayout>
    </React.Fragment>
  );

  function handleCloseSearchUser() {
    setOpenSearchUser(false);
  }
};

export default JourneyTeam;
